import { Injectable } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import { CoreRouterState } from './core-router.reducer';

@Injectable()
export class CoreRouterSerializer
  implements RouterStateSerializer<CoreRouterState>
{
  serialize(routerState: RouterStateSnapshot): CoreRouterState {
    let route = routerState.root;
    let parentRoute = void 0;

    while (route.firstChild) {
      parentRoute = route;
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams }
    } = routerState;
    const { params } = route;
    const parentRoutePath =
      parentRoute && parentRoute.routeConfig && parentRoute.routeConfig.path;

    return {
      url,
      params,
      queryParams,
      parentRoutePath
    };
  }
}
